<template>
  <div class="pilot-box">
    <a-spin class="spin-box" v-if="loading"></a-spin>
    <a-empty class="empty-box" :image="simpleImage" v-if="!loading && intList.length == 0" />
    <!-- 具体内容 -->
    <div class="popup-box video-box" :class="{ fold: isFold }" v-if="int">
      <div class="hanlder-box">
        <svg class="popup-close" @click="close()">
          <use xlink:href="#icon-guanbi" />
        </svg>
      </div>
      <a-empty class="empty-box" :image="simpleImage" v-if="int.allcode.length == 0" />
      <div class="nav-box">
        <div class="code-box">
          <div class="int-title">
            <span>课程内容</span>
            <span>{{ int.allcode.length }}节</span>
          </div>
          <div class="code-list">
            <div class="int-item" v-for="int in intList">
              <div class="int-title" @click="int.isFold = !int.isFold">
                <span>{{ int.InductionName }}</span>
                <svg class="icon-xiala" :class="{ isFold: int.isFold }">
                  <use xlink:href="#icon-xiala" />
                </svg>
              </div>
              <div class="cint-item" v-for="cint in int.children" v-if="!int.isFold">
                <div class="citem-title">{{ cint.InductionName }}</div>
                <div class="code-item" :class="{ selected: item == code }" v-for="(item, i) in int.allcode" @click="code = item">
                  <div class="code-num">{{ i + 1 }}</div>
                  <div class="code-title">第{{ i + 1 }}节 {{ item.Title }} - {{ item.ProjectName }}</div>
                  <div class="code-icon">
                    <!-- <svg class="icon-start" v-if="item == code">
                      <use xlink:href="#icon-start" />
                    </svg>-->
                    <svg class="icon-finish" v-if="item != code && item.isFinish">
                      <use xlink:href="#icon-duihao1" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <svg class="icon-omit" :class="{ omitfold: isFold }" @click="foldNav()">
          <use xlink:href="#icon-a-13Bshenglve" />
        </svg>
      </div>
      <iframe id="iframe-box" ref="iframeBox" class="iframe-content" :src="code.phoneIframe" scrolling="no" frameborder="0" name="ifd" @load="listenIframeBox()" v-if="code"></iframe>
      <show_achievement :showAchievement="showAchievement" type="remind" @closeBox="readedAchievement" v-if="showAchievement || isShowUpgrade"></show_achievement>
    </div>
  </div>
</template>

<script>
import { PASSPORT_CLIENT_SERVER } from '@/config/url';
import { Empty } from 'ant-design-vue';
import router from '@/router';
import show_achievement from "../../personal/achievement_list/show_achievement/show_achievement.vue";


export default {
  name: 'play',
  components: {
    show_achievement,
  },
  data() {
    return {
      isFold: false,
      loading: true,
      isShowUpgrade: false,

      classInfo: null,
      int: null,
      code: null,
      showAchievement: null,
      notShowAchievement: null,
      user: null,

      intList: [],

      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
    }
  },
  mounted() {
    const { userInfo, digitalBookList } = this.$store.state;
    this.digitalBookGuid = this.$route.params.id;
    this.user = userInfo;
    if (!userInfo) return location.href = `${PASSPORT_CLIENT_SERVER}/inner-training?redirectURI=${location.href}`;

    this.course = digitalBookList.find(item => item.pk_digital_book_id == this.digitalBookGuid);
    this.classGuid = this.course.fk_class_id;
    this.getNewInt();
  },
  methods: {
    //获取归纳
    async getNewInt() {
      let res = await this.$api.digitalBook.getInduction(this.classGuid);
      if (res.status != 1) {
        this.loading = false;
        return this.$message.warning('获取互动失败');
      }

      let intList = res.data || [];

      intList.forEach(int => {
        int.fold = false;
        int.allcode = [];
        int.children.forEach(cint => {
          cint.data = cint.data.filter(item => item.pushType != 'coursewarePushModel' && item.pushType != 'pushModel')
          cint.data.forEach(code => {
            code.phoneIframe = `${code.address}?noauth=1&tile=1&showtype=screenNav&fullscreeon=1`;
          });
          int.allcode = [...int.allcode, ...cint.data]
        });
        int.children = int.children.filter(cint => cint.data.length > 0);
      });

      this.intList = intList.filter(int => int.allcode.length > 0);

      if (this.intList.length > 0) {
        this.int = intList[0];
        if (this.int.allcode.length > 0) this.code = this.int.allcode[0];
      }
      this.loading = false;
      this.getScoreList();
    },
    //获取学生完成情况
    async getScoreList() {
      let res = await this.$api.unifydata.getScoreList({ userGuid: this.user.PK_UserGuid, classGuid: this.classGuid });
      if (res.statusCode != 200) return;
      let recordList = res.data.record || [];
      this.intList.forEach(int => {
        int.allcode.forEach(code => {
          let recode = recordList.find(item => item.id == code.Guid);
          if (recode) {
            if (recode.ProjectCode == 'mi' && recode.score == 100) code.isFinish = true;
            else if (res.state == 1) code.isFinish = true;
          }
        })
      })
      let { achievement, level } = res.data;
      this.notShowAchievement = achievement.filter(item => !item.isShow);
      //是否有未提示升级
      let notShowLevel = level.filter(item => !item.isShow && item.value > 0);
      this.isShowUpgrade = notShowLevel.length > 0 ? true : false;
      this.findNotShowAchievement();
    },
    //找到未提示成就
    async findNotShowAchievement() {
      let { PK_UserGuid: studentId } = this.user;
      let notShowAchievement = this.notShowAchievement;

      if (this.isShowUpgrade) {
        await this.$api.unifydata.showAchievement({ studentId, classId: this.classGuid, achievementId: "", type: "level" });
      }
      else {
        let showAchievement = notShowAchievement.length > 0 ? notShowAchievement[0] : null;
        if (showAchievement) {
          let { id } = showAchievement;
          await this.$api.unifydata.showAchievement({ studentId, classId: this.classGuid, achievementId: id, type: "achievement" });
        }
        this.showAchievement = showAchievement;
      }
    },
    //已读
    async readedAchievement() {
      if (this.showAchievement) {
        let { id } = this.showAchievement;
        this.notShowAchievement = this.notShowAchievement.filter(item => item.id != id);
      }
      else this.isShowUpgrade = false;
      this.findNotShowAchievement();
    },
    //关闭弹窗
    close() {
      let query = this.$route.query;
      if (query && query.last) {
        router.push(`/${query.last}`);
      }
      else router.push(`/course-info/${this.digitalBookGuid}`);
    },
    //选择code
    chooseInt(item) {
      this.int = item;
      if (item.allcode.length > 0) this.code = item.allcode[0];
    },
    //折叠
    foldNav() {
      this.isFold = !this.isFold;
    },
    //监听iframe弹窗
    listenIframeBox() {
      let that = this;
      this.$nextTick(() => {
        let iframe = that.$refs["iframeBox"];
        //发送值
        iframe.contentWindow.postMessage({
          command: 'postStudentId',
          data: {
            studentId: this.user.PK_UserGuid,
          },
        }, '*')
      })
    },
  },

}


</script>

<style scoped lang="scss">
@import "./play.scss";
</style>